<template>
  <div class="p-2">
    <div class="flex gap-4 overflow-scroll p-3 no-scrollbar snap-x" ref="test">
      <MonthViewer
        v-for="month in 12"
        :key="month"
        :month="month"
        :active="month === selectedMonth"
        @monthClicked="
          selectedMonth = $event;
          selectedDay = '';
        "
      />
    </div>

    <div class="flex gap-4 overflow-scroll no-scrollbar snap-x py-2">
      <DayViewer
        v-for="day in daysInMonth"
        :key="day"
        :day="day"
        :month="selectedMonth"
        :active="day === selectedDay"
        @dayClicked="selectedDay = $event"
      />
    </div>

    <!-- Numbers Box -->
    <div
      class="relative flex justify-between bg-gray-900 rounded-lg mt-3 p-4 overflow-hidden"
    >
      <div>
        <UsersIcon class="h-6 w-6 text-red-500" />
        <h6 class="text-white text-sm mt-2">
          {{ summaryData.mehmanInCount }} نفر
        </h6>
        <span class="text-gray-400 text-xs">ورودی</span>
      </div>
      <div>
        <UsersIcon class="h-6 w-6 text-red-500" />
        <h6 class="text-white text-sm mt-2">
          {{ summaryData.mehmanInOutCount }} نفر
        </h6>
        <span class="text-gray-400 text-xs">خروجی</span>
      </div>
      <div>
        <CashIcon class="h-6 w-6 text-red-500" />
        <h6 class="text-white text-sm mt-2">
          {{ $helper.numberShortener(summaryData.incomeInday) }}
        </h6>
        <span class="text-gray-400 text-xs">درآمد</span>
      </div>
      <div>
        <FireIcon class="h-6 w-6 text-red-500" />
        <h6 class="text-white text-sm mt-2">
          {{ summaryData.avgInMonth }} روز
        </h6>
        <span class="text-gray-400 text-xs">اقامت ماهیانه</span>
      </div>

      <div
        class="absolute flex items-center justify-center bg-gray-900/80 left-0 right-0 top-0 bottom-0"
        v-if="loading"
      >
        <LoadingSpinner class="h-7 w-7 text-yellow-500" />
      </div>
    </div>

    <div class="grid grid-cols-1 gap-2 mt-4">
        <CountByCity :day="selectedDay" :month="selectedMonth" />
    </div>
    <div class="grid grid-cols-1 gap-2 mt-4">
      <CountByJob :day="selectedDay" :month="selectedMonth" />
    </div>
    <div class="grid grid-cols-1 gap-2 mt-4">
      <CountByOrganization :day="selectedDay" :month="selectedMonth" />
    </div>
    <div class="grid grid-cols-1 gap-2 mt-4">
      <CountByNashnality :day="selectedDay" :month="selectedMonth" />
    </div>

    <OrganizationTreemap :day="selectedDay" :month="selectedMonth" />
  </div>
</template>
<script>
import DayViewer from "../../components/Management/DayViewer";
import { CashIcon, FireIcon, UsersIcon } from "@heroicons/vue/outline";
import { getSummeryDataHotel } from "../../API/API";
import LoadingSpinner from "../../components/General/LoadingSpinner";
import MonthViewer from "../../components/Management/MonthViewer";
import jDate from "jalali-date";
import CountByCity from "../../components/ManagementHotel/CountByCity.vue";
import CountByJob from "../../components/ManagementHotel/CountByJob.vue";
import CountByOrganization from "../../components/ManagementHotel/CountByOrganization.vue";
import CountByNashnality from "../../components/ManagementHotel/CountByNashnality.vue";
import OrganizationTreemap from "../../components/ManagementHotel/OrganizationTreemap.vue";

export default {
  name: "AnalyticsHotel",
  components: {
    MonthViewer,
    LoadingSpinner,
    DayViewer,
    CashIcon,
    UsersIcon,
    FireIcon,
    CountByCity,
    CountByJob,
    CountByOrganization,
    CountByNashnality,
    OrganizationTreemap,
  },
  data() {
    return {
      selectedDay: new jDate().getDate(),
      selectedMonth: new jDate().getMonth(),
      daysInMonth: "",
      summaryData: {},
      loading: true,
    };
  },
  created() {
    this.getDaysInMonth();
    this.getSummery();
  },
  methods: {
    async getSummery() {
      this.loading = true;
      this.summaryData = (
        await getSummeryDataHotel(
          "day",
          "",
          this.selectedMonth,
          this.selectedDay
        )
      ).data.result;
      this.loading = false;
    },
    getDaysInMonth() {
      let today = new jDate();
      // this.daysInMonth = jDate.daysInMonth(today.getFullYear(), this.selectedMonth)
      if (this.selectedMonth <= 6) {
        this.daysInMonth = 31;
        return;
      }

      if (this.selectedMonth <= 11) {
        this.daysInMonth = 30;
        return;
      }

      if (jDate.isLeapYear(today.getFullYear())) {
        this.daysInMonth = 30;
        return;
      }

      this.daysInMonth = 29;
      return;
    },
  },
  watch: {
    selectedDay() {
      if (this.selectedDay !== "") {
        this.getSummery();
      }
    },
    selectedMonth() {
      this.getDaysInMonth();
      this.getSummery();
    },
  },
};
</script>
<style scoped></style>
